export class WearLevel {
  id: number;
  name: string;

  constructor() {
    this.id = 0;
    this.name = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/+core/common/model/wear-level.model.ts